import {getCustomForm} from './get';
import {customSave} from './save';
import {$subscriber, cr} from 'fire-wind-water';

import {createFILE} from '../../controllers/events/file';
import {createTEXT} from '../../controllers/events/text';
import {createTIME} from '../../controllers/events/time';
import {createLIST} from '../../controllers/events/list';
import {createLINE} from '../../controllers/events/line';
import {createDESC} from '../../controllers/events/desc';
import {createPOLICY} from '../../controllers/events/policy';

import * as field from '../../../art/form/field.art';

$subscriber.subscribe('s-load-customform', (res) => {
  const customFormId = res.customFormId;
  const customFormList = document.querySelectorAll(`.customform-${customFormId}`);
  const customFormButton = document.querySelectorAll(`.custom-button-${customFormId}`);
  if (res.items.length === 0) {
    cr.each(customFormList, (d) => {
      d.style.display = 'block';
    });
    return;
  }
  const items = [];
  cr.each(res.items, (d) => {
    switch (d.fieldType) {
      case 'TEXT':
        const text = createTEXT(d);
        items.push(text);
        break;
      case 'LIST':
        const list = createLIST(d);
        if (list) {
          items.push(list);
        }
        break;
      case 'FILE':
        const file = createFILE(d);
        items.push(file);
        break;
      case 'DATETIME':
        const time = createTIME(d);
        items.push(time);
        break;
      case 'LINE':
        const line = createLINE(d);
        items.push(line);
        break;
      case 'DESC':
        const desc = createDESC(d);
        items.push(desc);
        break;
      case 'POLICY':
        const policy = createPOLICY(d);
        items.push(policy);
        break;
    }
  });
  const str = field({items: items, type: 'customForm'});
  cr.each(customFormList, (d) => {
    d.style.display = 'block';
    d.innerHTML = str;
  });
  cr.each(customFormButton, (d) => {
    d.style.display = 'block';
  });
});

// let isReset = true; //是否归位
//
// function focusinHandler() {
//   isReset = false; //聚焦时键盘弹出，焦点在输入框之间切换时，会先触发上一个输入框的失焦事件，再触发下一个输入框的聚焦事件
// }
//
// function focusoutHandler() {
//   isReset = true;
//   setTimeout(() => {
//     //当焦点在弹出层的输入框之间切换时先不归位
//     if (isReset) {
//       window.scroll(0, 0); //确定延时后没有聚焦下一元素，是由收起键盘引起的失焦，则强制让页面归位
//     }
//   }, 30);
// }
//
// document.body.addEventListener('focusin', focusinHandler);
// document.body.addEventListener('focusout', focusoutHandler);

export {
  getCustomForm,
  customSave
};